<div class="search-results" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollUpDistance]="1.5"
  [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" (scrolledUp)="onScrollUp()" [fromRoot]="true">
  <app-ecom-header class="bg-white" (submitted)="headerEventEmitter($event)"></app-ecom-header>
  <div class="mt-2 bg-white">
    <div class="container" *ngIf="!ecomservice.loadingPage.loading">
      <div [@inOutAnimation]="'in'" class="row form-group no-gutters border-light-grey border-radius-0 mb-2"
        *ngFor="let locationDetails of locationList;let i=index">
        <div class="col cursor">
          <div class="row no-gutters form-group bg-white p-2  pt-1 pb-3 m-0  border-radius-10">
            <div class="col-3" (click)="onLocationClick(locationDetails)">
              <img [lazyLoad]="locationDetails.oocls_banner_image_name" [defaultImage]="defaultImage"
                class="img-fluid img-location border-radius-4" alt="location image">
            </div>
            <div class="col-9 pl-3">
              <div class="row">
                <div class="col">
                  <div class="float-right ml-1" (click)="onMapIconClick(locationDetails)">
                    <div class="font-size-90">
                      <span class="">
                        <i class="fas fa-map-marker icon-color-grey"></i> {{locationDetails.location_distance}}
                      </span>
                    </div>
                    <div class="float-right">
                      <img loading="lazy" src="assets/images/google-maps.png" class="icon-google-maps">
                    </div>

                  </div>
                  <div class="" (click)="onLocationClick(locationDetails)">
                    <small class="card-title font-weight-bold h6 text-capitalize text-break">
                      {{locationDetails.oocls_company_name}}
                    </small>
                  </div>
                  <div class="font-size-90 font-weight-bold-500 mb-1" (click)="onLocationClick(locationDetails)">
                    <span class="text-muted text-capitalize text-break">{{locationDetails.oocls_location_name}}</span>
                  </div>

                  <div class="mb-1" (click)="onLocationClick(locationDetails)">
                    <span class="mb-1" *ngIf="locationDetails && locationDetails.oocls_is_delivery">
                      <span class="">
                        <i class="fas fa-motorcycle font-color-dark-blue pr-1"></i> Deliver
                        <span *ngIf="locationDetails && locationDetails.oocls_company_symbol_position === 'BACK'">
                          {{locationDetails.oocls_company_default_currency_symbol}}
                        </span>
                        {{locationDetails.oocls_delivery_charge_5}}
                        <span *ngIf="locationDetails && locationDetails.oocls_company_symbol_position === 'FRONT'">
                          {{locationDetails.oocls_company_default_currency_symbol}}
                        </span>
                      </span>upto 5KM
                    </span>
                  </div>
                  <div class="font-size-90" (click)="onLocationClick(locationDetails)">
                    <span class="font-color-dark-orange" *ngIf="locationDetails.oocls_promotional_message">
                      <i class="fas fa-star font-color-dark-orange small"></i>
                      {{locationDetails.oocls_promotional_message}}
                    </span>
                  </div>
                  <div class="font-size-90 text-white" *ngIf="locationDetails.oocls_slider_promotional_message"
                    (click)="onLocationClick(locationDetails)">
                    <span style="border: 1px solid black !important; border-radius: 1px !important; background:purple;"
                      class="px-2" *ngIf="locationDetails.oocls_slider_promotional_message">
                      {{locationDetails.oocls_slider_promotional_message}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="locationDetails.list_location_items">
            <div *ngFor="let item of locationDetails.list_location_items">
              <div class="row form-group pl-4 no-gutters align-items-center" *ngIf="item.item_name"
                (click)="onItemSelect(item,locationDetails)">
                <div class="col-3 pl-2 pr-2 itemimage">
                  <img *ngIf="item.oocip_image && item.oocip_image.length > 0" [defaultImage]="defaultItemImage"
                    [lazyLoad]="item.oocip_image" class="card-img img-fluid img-item" alt="location image">
                  <img *ngIf="!item.oocip_image" [defaultImage]="defaultItemImage" [lazyLoad]="defaultItemImage"
                    class="img-fluid card-img-top store-image" alt="location image">
                </div>
                <div class="col-6">
                  <div class="font-weight-bold-500 h6 mb-0">
                    {{ecomservice.htmlUtil.textTruncate(item.item_name, 42)}}
                  </div>
                </div>
                <div class="col-3">
                  <div *ngIf="item.oocip_delivery_discount_price_value !== 0">
                    <div>
                      <span class="card-text font-size-16 font-weight-bold-500 font-size-price pl-2 pr-2">
                        <del> {{item.oocip_price_value.toFixed(2)}}</del>
                      </span>
                    </div>
                    <span class="card-text font-size-16 font-weight-bold-500 font-size-price pl-2 pr-2">
                      {{item.oocip_delivery_discount_price_value.toFixed(2)}}
                    </span>
                  </div>
                  <div *ngIf="item.oocip_delivery_discount_price_value === 0">
                    <span class="card-text font-size-16 font-weight-bold-500 font-size-price pl-2 pr-2">
                      {{item.oocip_price_value.toFixed(2)}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="locationList.length === 0" class="text-center">
        <label for="" class="text-danger" *ngIf="noRestaurants">No restaurants found, modify your search</label>
        <label for="" class="text-danger" *ngIf="restaurantFetch">Fetching your nearest location. Please wait
          ...</label>
      </div>
      <!-- Empty div to scroll till bottom -->
      <div class="row mt-5 pt-2"></div>
    </div>
  </div>
  <app-ecom-footer class="footer bg-white"></app-ecom-footer>
</div>


<ng-template #locationmap>
  <div class="modal-header">
    <i class="fas fa-times fa-lg cursor close" (click)="onCloseMapClick()"></i>
  </div>
  <div class="modal-body mapcontainer">
    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false"
      (mapClick)="mapClicked($event)">

      <agm-marker *ngFor="let m of markers; let i = index" (markerClick)="clickedMarker(m.label, i)" [latitude]="m.lat"
        [animation]="mapAnimation" [longitude]="m.lng" [label]="m.label" [iconUrl]="m.iconUrl"
        [markerDraggable]="m.draggable" (dragEnd)="markerDragEnd(m, $event)">

        <agm-info-window [isOpen]="true">
          <div class="container">
            <div class="row form-group">
              <div class="col">
                <div>
                  <strong>{{companyName}}</strong>
                </div>
                <span class="">Address: {{locationAddress}}</span>
                <div>
                  <a (click)="mapsNavigate()" class="text-primary cursor">view on googlemaps</a>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col">
                <br />
              </div>
            </div>
          </div>
        </agm-info-window>

      </agm-marker>

      <agm-circle [latitude]="lat + 0.3" [longitude]="lng" [radius]="5000" [fillColor]="'red'" [circleDraggable]="true"
        [editable]="true">
      </agm-circle>

    </agm-map>
  </div>
</ng-template>
<app-loading-component></app-loading-component>
<ecom-scroll-to-top></ecom-scroll-to-top>